<template>
    <div class="home">
        <div class="home_header">
            <div class="home_header--name">
                Привет, {{this.$store.getters.userName}}
            </div>
            <div class="home_header--deposit" v-if="clubSettings?.modules?.balance?.enable">
                <i>
                    <img src="../assets/img/money-bag.png" alt="">
                </i>
                Мой счет <span class="value"><currency-symbol :price="this.$store.getters.userDeposit"/></span>
            </div>
        </div>

        <div class="home_content">
            <div class="row">
                <div class="col-lg-7 col-12">
                    <span class="home_content--label">
                        Ближайшие записи
                    </span>
                    <div class="home_content--schedule">
                        <reservation-list :events="events" />
                    </div>
                </div>
                <div class="col-lg-5 col-12">
                    <span class="home_content--label">
                        Абонементы и услуги
                    </span>
                    <div class="home_content--items">
                        <div class="items_navs">
                            <div
                                class="items_nav"
                                :class="{active: activeTab === 'contracts'}"
                                @click="activeTab = 'contracts'">
                                Абонементы
                            </div>
                            <div
                                class="items_nav"
                                :class="{active: activeTab === 'services'}"
                                @click="activeTab = 'services'">
                                Услуги
                            </div>
                        </div>
                        <div class="items_tabs">
                            <div
                                class="items_tab"
                                :class="{active: activeTab === 'contracts'}"
                            >
                                <items-list
                                    :items="contracts"
                                    :items-type="'contracts'"
                                />
                            </div>
                            <div
                                class="items_tab"
                                :class="{active: activeTab === 'services'}"
                            >
                                <items-list
                                    :items="services"
                                    :items-type="'services'"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="home_app_banner">
            <app-banner />
        </div>
    </div>
</template>

<script>
    import ReservationList from "../components/ReservationList";
    import ItemsList from "../components/ItemsList";
    import AppBanner from "../components/AppBanner";
    import CurrencySymbol from "../components/CurrencySymbol";

    export default {
        name: 'Home',
        components: {CurrencySymbol, ReservationList, ItemsList, AppBanner },
        data() {
            return {
                activeTab: 'contracts',
            }
        },
        computed: {
            events: function() {
                return this.$store.getters.reservations
            },
            contracts: function () {
                return this.$store.getters.contracts
            },
            services: function () {
                return this.$store.getters.services
            },
            clubSettings: function () {
              try {
                return this.$store.getters.settings;
              } catch (e) {
                return null
              }
            }
        },
        created() {
            if (this.$store.getters.token !== ''){
                this.$store.dispatch('loadHomeData')
            }
        }
    }
</script>
